var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBubble(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "eXvkQfh43iR1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 351 282",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "eXvkQfh43iR3-fill",
    x1: 90.2788,
    y1: 203.113,
    x2: 367.515,
    y2: -29.1851,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eXvkQfh43iR3-fill-0",
    offset: "0%",
    stopColor: "#b0f5ca"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eXvkQfh43iR3-fill-1",
    offset: "100%",
    stopColor: "#8fd3f4"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "eXvkQfh43iR3",
    d: "M184.217,16.0415c58.82.7312,124.235,14.7391,142.493,66.1821c18.312,51.5954-25.049,98.9634-72.378,131.3694-49.68,34.016-112.79,62.06-164.6523,30.923C30.9642,209.266,4.41424,138.807,29.3565,78.527C51.5259,24.9488,121.905,15.2668,184.217,16.0415Z",
    transform: "translate(.48954 0)",
    clipRule: "evenodd",
    fill: "url(#eXvkQfh43iR3-fill)",
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubble);
export default __webpack_public_path__ + "static/media/bubble.989133dfc443b2abbc44dc58013f11b7.svg";
export { ForwardRef as ReactComponent };